<template>

  <table-layout title="زمان بندی" :showSearch="false">

    <template #buttons>

      <b-button pill v-b-modal.create-timing variant="primary">ایجاد زمان بندی</b-button>
      <b-modal size="lg" id="create-timing" class="show" hide-footer>
        <create-form :page="page"  :filters="filters"/>
      </b-modal>

    </template>

    <template #table>

      <timing-filters-component @typeChanged="resetPage" @filters="changeFilters" class="my-5"/>

      <b-row>
        <div class="col-lg-4 col-md-6 col-sm-12 my-2" v-for="item in timings" :key="item.id">
          <timing-card :page="page" :filters="filters" :class="{'expire-timing-item':!isActiveTiming(item.open_at,item.close_at)}"
                       class="my-2" :item="item"/>
        </div>
      </b-row>
      <b-row align-h="center">
        <m-pagination-400 :meta="paginate" :on-change-page="changePage"/>
      </b-row>

    </template>
  </table-layout>

</template>

<script>
import {mapGetters} from "vuex";
import {
  isActiveTiming,
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import TableLayout from "../../components/dashboard/TableLayout";
import tableItems from "../../components/dashboard/Content/tableItemsForLesson";
import Pagination from "../../components/dashboard/Pagination";
import TimingCard from "../../components/dashboard/Timing/TimingCard";
import TimingFiltersComponent from '../../components/dashboard/Timing/TimingFilters'
import CreateForm from "../../components/dashboard/Timing/CreateForm";

export default {
  name: "Timing",
  components: {
    TableLayout,
    tableItems,
    Pagination,
    TimingCard,
    TimingFiltersComponent,
    CreateForm,
  },
  data() {
    return {
      page: 1,
      filters: {
        timable_type: 'all',
      }
    }
  },
  computed: {
    ...mapGetters({
      timings: "Timing/getTimings",
      paginate: 'Timing/getMeta'
    }),
  },
  methods: {
    isActiveTiming,
    changePage(page) {
      this.page = page
      this.$store.dispatch('Timing/getTimings', {page: this.page, form: this.filters})
      this.$router.push({name: this.$route.name, query: {page: page}})
    },
    async changeFilters(filters) {
      this.filters = await filters
      await this.$store.dispatch('Timing/getTimings', {page: this.page, form: this.filters})
      await this.$router.push({name: this.$route.name, query: {page: this.page}})
    },
    resetPage() {
      this.page = 1
    }
  },
  mounted() {

    if (this.$route.query.page != undefined) {
      this.page = this.$route.query.page
    }

    this.$store.dispatch('Timing/getTimings', {page: this.page, form: this.filters})
  }

}
</script>

<style scoped>
.expire-timing-item {
  border: 2px solid #dc2530;
}
</style>